import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../services/session.service';
import { APP_ROUTES } from '../constants/app-route.constants';
export const PermissionGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const session = inject(SessionService);

  const token = session.token();

  if (!token) {
    router.navigateByUrl(APP_ROUTES.AUTH.LOGIN);
    return false;
  }

  const required = route.data['requiredAccess'] as {
    module: string;
    action?: string;
    actions?: string[];
  };

  if (!required) {
    return true;
  }

  const access = session.access();

  if (!access?.length) {
    router.navigateByUrl(APP_ROUTES.NO_ACCESS);
    return false;
  }

  const requiredActions = (
    required.actions ?? (required.action ? [required.action] : [])
  ).map((a) => String(a).trim().toUpperCase());

  const requiredModule = String(required.module).trim().toUpperCase();

  let hasPermission = false;

  for (const m of access) {
    const moduleName = String(m.moduleName).trim().toUpperCase();

    if (moduleName !== requiredModule) continue;

    for (const a of m.actions || []) {
      const actionName = String(a.actionName).trim().toUpperCase();

      if (requiredActions.includes(actionName)) {
        hasPermission = true;
        break;
      }
    }

    if (hasPermission) break;
  }

  if (!hasPermission) {
    router.navigateByUrl(APP_ROUTES.NO_ACCESS);
    return false;
  }

  return true;
};
